export default "__VITE_ASSET__LRiXcQ____"